import { apiClient } from "../config";

async function getObservationProfile(observationId: any) {
  const res = await apiClient.get(`/admin/observations/${observationId}`);
  return res.data;
}

export default getObservationProfile;
